/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Job_Deleted_SuccessInputs */



/**
* | output |
* | --- |
* | "Shot description job deleted successfully." |
*
* @param {Scene_Description_Job_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_job_deleted_success = /** @type {((inputs?: Scene_Description_Job_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Job_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du plan supprimée avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Auftrag für die Aufnahmebeschreibung wurde erfolgreich gelöscht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione dell'inquadratura eliminata con successo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание задания успешно удалено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La descripción de la toma se eliminó correctamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头描述任务已成功删除。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("撮影内容の説明は正常に削除されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट विवरण कार्य सफलतापूर्वक हटा दिया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição da foto excluída com sucesso.")
	return /** @type {LocalizedString} */ ("Shot description job deleted successfully.")
});